import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaTentativasRealizadas = (): TabelaColuna => ({
  Chave: 'tentativasRealizadas',
  Alinhamento: 'center',
  ComOrdenacao: true,
  RenderizarCabecalho: () => (
    <div style={{ width: 100 }}>Tentativas Realizadas</div>
  )
})
